import React from "react";
import { X } from "lucide-react";
import { highlightText } from "../../utils/textAnalysis";

const SongModal = ({ selectedSong, onClose, highlightWord }) => {
  if (!selectedSong) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="glass-card rounded-lg max-w-4xl w-full max-h-[80vh] overflow-hidden bg-forest-800">
        <div className="flex items-center justify-between p-6 border-b border-forest-600">
          <h2 className="text-xl font-semibold text-forest-100">
            {selectedSong.title}
          </h2>
          <button
            onClick={onClose}
            className="text-forest-300 hover:text-forest-200 transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto max-h-[60vh]">
          <pre className="whitespace-pre-wrap leading-relaxed text-forest-200">
            {highlightWord
              ? highlightText(selectedSong.lyrics, highlightWord)
              : selectedSong.lyrics}
          </pre>
        </div>
      </div>
    </div>
  );
};

export default SongModal;
